var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// BluePrint JS
import { DateRangePicker as BPDateRangePicker } from "@blueprintjs/datetime";
import classNames from 'classnames';
// constants
import { prefix } from '../../constants';
export const DateRangePicker = (_a) => {
    var props = __rest(_a, []);
    return React.createElement(BPDateRangePicker, Object.assign({ className: classNames(`${prefix}-daterangepicker`, { datepicker: true }) }, props, { allowSingleDayRange: true }));
};
//# sourceMappingURL=DateRangePicker.js.map